module.exports = __webpack_public_path__ + "img/banner-pumpkin-pc.38418492.png";